import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ContractorDashboardComponent } from './contractor-dashboard/contractor-dashboard.component';
import { ContractorFlowRoutingModule } from './contractor-flow-routing.module';
import { MatCardModule } from '@angular/material/card';
import { ContractorLeaveComponent } from './contractor-leave/contractor-leave.component';
import { ContractorTimesheetComponent } from './contractor-timesheet/contractor-timesheet.component';
import { ContractorApplyLeaveComponent } from './contractor-apply-leave/contractor-apply-leave.component';
import { SharedModule } from '@shared/shared.module';
import { SearchFieldComponent } from '@shared/components/search-field/search-field.component';
import { TimesheetCalendarComponent } from '@pages/vendor-rep/timesheet-calendar/timesheet-calendar.component';
import { FileUploadComponent } from '@app/shared/components/file-upload/file-upload.component';
import { DropdownComponent } from '@app/shared/components/dropdown/dropdown.component';
import { DateRangeComponent } from '@app/shared/components/date-range/date-range.component';
import { ConfirmationDialogComponent } from '@shared/components/confirmation-dialog/confirmation-dialog.component';

@NgModule({
  declarations: [
    ContractorDashboardComponent,
    ContractorLeaveComponent,
    ContractorTimesheetComponent,
    ContractorApplyLeaveComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ContractorFlowRoutingModule,
    MatCardModule,
    SharedModule,
    SearchFieldComponent,
    TimesheetCalendarComponent,
    FileUploadComponent,
    DropdownComponent,
    DateRangeComponent,
    ConfirmationDialogComponent,
  ],
})
export class ContractorFlowModule {}
